<template>
  <transition name="slide-fade">
    <div class="container marker" v-if="active && $store.state.fahrttyp === 'ascent'">
      {{ $t('fahrtView.label.reservationFeeHint') }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ReservationFee',
  data() {
    return {
      active: false
    }
  },
  mounted() {
    this.active = true
  }
}
</script>

<style scoped lang="scss">
.marker {
  padding-top: 15px;
  width: 30%;
  position: relative;
  display: block;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  @media screen and (max-width: 1500px) {
    width: 40%;
  }
  @media screen and (max-width: 1000px) {
    width: 50%;
  }
  @media screen and (max-width: 650px) {
    width: 90%;
  }
}
</style>